import http from "@/helper/http";
import {BaseVO, GetByIdBO, GetByIdsBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {MonitorPO} from "@/model/product";
import {WritePatentForm} from "@/pages/Patent/WritePatent";
import {PatentEnum} from "@/service/patent.s";

export enum MonitorEnum {
    GetMonitorPage = "/monitor/getMonitorPage",
    GetMonitor = "/monitor/getMonitor",
    GetReminderPage = "/monitor/getReminderPage",
    SearchMonitor = "/monitor/searchMonitor",
    ExportReminder = "/monitor/exportReminder",
    CreateMonitor = "/monitor/createMonitor",
}

export interface ReminderPageBO extends PaginationBO {
    status: string
}

export interface MonitorVO {
    id: number;
    patentName: string;
    applyNo: string;
    patentStatus: string;
    category: string;
    retard: string
    seller: string;
    applyDate: Date
    writer: string;
    customerName: string;
    monitors: MonitorPO[];
}


export interface MonitorPageBO {
}

export interface ReminderPageVO {
    id: number;
    patentName: string;
    patentNo: string;
    categoryId: number;
    category: string;
    applyDate: Date;
    isMonitor: number
    patentStatus: string;
    patentStatusId: number;
    seller: string;
    customerName: string;
}

export interface MonitorPageVO extends MonitorPO {
    customerName: string;
    categoryId: number;
    applyNo: string;
    seller: string;
    category: string;
    applyDate: Date;
}

export interface SearchMonitorBO {
    patentId: number
}

export interface SearchMonitorVO {
    feeType: string
    feeId: number
    paymentStatus: number
}

export const useQueryReminderPage = () => useMutation({
    mutationFn: (data: ReminderPageBO) => http.post<BaseVO<PaginationVO<ReminderPageVO>>>({
        url: MonitorEnum.GetReminderPage,
        data: data,
    }),
})

export const useExportReminder = () => useMutation({
    mutationFn: (data: any) => http.post<Blob>({
        url: MonitorEnum.ExportReminder,
        responseType: "arraybuffer",
        data: data,
    }),
})


export const useSearchMonitor = () => useMutation({
    mutationFn: (data: SearchMonitorBO) => http.post<BaseVO<SearchMonitorVO[]>>({
        url: MonitorEnum.SearchMonitor,
        data: data,
    }),
})

export const useQueryMonitorPage = () => useMutation({
    mutationFn: (data: MonitorPageBO) => http.post<BaseVO<PaginationVO<MonitorPageVO>>>({
        url: MonitorEnum.GetMonitorPage,
        data: data,
    }),
})

export const useQueryMonitor = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<MonitorVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<MonitorVO>>({
        url: MonitorEnum.GetMonitor,
        params: params
    }),
    enabled
})


// 加入年费监控
export const useCreateMonitor = () => useMutation({
    mutationFn: (data: GetByIdsBO) => http.put<BaseVO<null>>({url: MonitorEnum.CreateMonitor, data}),
})

